<template>
  <div>
    <QualificationsSentToast />
    <AddedToCartToast />
    <QualificationTransferEmailFailedToast />
    <ReclaimToast />
    <ReclaimErrorToast />
    <PurchaseIntentError />
  </div>
</template>

<script>

import PurchaseIntentError from './PurchaseIntentError.vue'
import QualificationTransferEmailFailedToast from './QualificationTransferEmailFailedToast.vue'
import ReclaimErrorToast from './QualificationReclaimErrorToast.vue'
import ReclaimToast from './QualificationReclaimToast.vue'
import AddedToCartToast from './AddedToCartToast.vue'
import QualificationsSentToast from './QualificationsSentToast.vue'

export default {
  components: {
    QualificationsSentToast,
    PurchaseIntentError,
    QualificationTransferEmailFailedToast,
    ReclaimErrorToast,
    ReclaimToast,
    AddedToCartToast,
  },
}
</script>
<style lang="scss" scoped>

</style>
